import { requests } from "App/api/agent/agent";
import { HttpStatusCodeResponse } from "App/types/httpResponse";
import { SubmitContactFormRequest } from "./requests";

export const ContactApi = {
    submitContactForm: (body: SubmitContactFormRequest): Promise<HttpStatusCodeResponse> => requests.post(`/contact`, body),
}